import React, { Component } from 'react';
import Catalogue from '../components/Catalogue';
import "../css/general-style.css";
import '../css/table-responsive.css';
import "../css/pickingSystem-style.css";
import { AiOutlineSearch, AiTwotoneSave, AiOutlineCheckCircle, AiOutlineClockCircle, AiOutlineCloseCircle, AiOutlineZoomIn, AiOutlineMinusSquare } from "react-icons/ai";
import { BsFileArrowUpFill, BsFileArrowDownFill } from "react-icons/bs";
import ModalOrders from '../components/ModalComponent';
import { getValueCookie } from '../services/cookieService';
import { create_Delete_Update_Information, getInformationWithData, getInformationWithDataGlobalSales } from '../services/CABE';
import { DateFormatMAS90, formatInputDateQuery, FormatQueryReturnDateForReport, getActualDateUTC } from '../functions/dateFormat';
import { getIndexElement } from '../functions/searchInObject';
import Swal from 'sweetalert2';
import { OrderPDF } from '../components/OrderPDF';
import { getPrintHeaderCompany } from '../functions/companyInformation';
import { pricesFormat } from '../functions/pricesFormat';
import SearchUPC from '../components/SearchUPC';
import { DecimalPart, decimalToHour, DeleteStrangeCharacter, MobileDisp, NumberFormat, OrderArray, ReplaceCharacter, validateNumbersForQuantitys } from '../functions/generalFunctions';
import { confirmCloseAlert } from '../functions/alerts';
import LoadingWindow from '../components/LoadingWindow';
import { DownloadOrderPDF } from '../components/DownloadOrderPDF';
import { NotificationBell } from '../components/NotificationBell';
import server from "../services/Connection/backEndLink";
import axios from "axios";

export default class PickingSystem extends Component {
    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
    }
    state = {
        Inventory: [],
        General: {
            ModeTitle: 'Sales Order',
            Mode: 'S/O',
            Colorclass: 'purpleLightButton',
            showModal1: false,
            showModal2: false,
            currentPallet: '01'
        },
        bandera: true,
        OrderHeaderList: [],
        filteredOrderList: [],
        searchSO: '',
        OrderDetailPicked: [],
        OrderDetailPickedToPrint: [],
        OrderDetailtoPick: [],
        ActualHeaderOrder: {
            Status: '',
            OrderNo: '',
            OrderName: '',
            OrderName2: '',
            OrderNameNo: '',
            OrderNameAddress: '',
            OrderNameCity: '',
            Date: '',
            SalesPerson: '',
            ZipCode: '',
            State: '',
            Order: null,
            Packing: ''
        },
        CurrentItem: {
            ItemCode: '',
            Description: '',
            onHand: 0,
            QuantityOrdered: 0,
            QuantityShipRec: 0,
            BIN: '',
            Pallet: '',
            UnitPrice: '',
            ImgURL: '',
            RegisterType: '',
            HaveUPC: false,
            DueDate: null
        },

        Totals: {

            OrderDetailtoPick: {
                QuantityOrdered: 0,
                TotalWeight: 0
            },
            OrderDetailPicked: {
                QuantityOrdered: 0,
                QuantityShipRec: 0,
                TotalWeight: 0
            }
        },
        companyPrintHeader: getPrintHeaderCompany(),
        PercentageScanning: 0,
        PercentageManual: 0,
        TotalManual: 0,
        TotalScanning: 0,
        order: true,
        changedSOItems: [],
        showCustomerTab: true,
    }

    clearAll() {
        const temporal = this.state.General
        temporal.currentPallet = '01'
        this.setState({
            OrderHeaderList: [],
            filteredOrderList: [],
            OrderDetailPicked: [],
            OrderDetailPickedToPrint: [],
            OrderDetailtoPick: [],
            ActualHeaderOrder: {
                Status: '',
                OrderNo: '',
                OrderName: '',
                OrderName2: '',
                OrderNameNo: '',
                OrderNameAddress: '',
                OrderNameCity: '',
                Date: '',
                SalesPerson: '',
                ZipCode: '',
                State: '',
                Order: null,
                Packing: ''
            },
            CurrentItem: {
                ItemCode: '',
                Description: '',
                onHand: 0,
                QuantityOrdered: 0,
                QuantityShipRec: 0,
                BIN: '',
                Pallet: '',
                UnitPrice: '',
                ImgURL: '',
                RegisterType: '',
                HaveUPC: false,
                DueDate: null
            },

            Totals: {

                OrderDetailtoPick: {
                    QuantityOrdered: 0,
                    TotalWeight: 0
                },
                OrderDetailPicked: {
                    QuantityOrdered: 0,
                    QuantityShipRec: 0,
                    TotalWeight: 0
                }
            },
            General: temporal,
            PercentageManual: 0,
            PercentageScanning: 0,
            TotalManual: 0,
            TotalScanning: 0
        })
    }

    changeMode() {
        const temp = this.state.General
        if (temp.Mode === 'S/O') {
            temp.Colorclass = 'orange'
            temp.Mode = 'P/O'
            temp.ModeTitle = 'Purchase Order'
        } else {
            temp.Colorclass = 'yellow'
            temp.Mode = 'S/O'
            temp.ModeTitle = 'Sales Order'
        }
        this.setState({ General: temp })
        this.clearAll()
    }

    componentDidMount() {
        //this.setState({ companyPrintHeader: getPrintHeaderCompany() })
    }

    handleModalOpen = (modal) => {
        const temporal = this.state.General
        temporal[modal] = true
        this.setState({ General: temporal })
    }

    handleModalClose = (modal) => {
        const temporal = this.state.General
        temporal[modal] = false
        this.setState({ General: temporal })
        if (modal === "showModal2") {
            this.clearCurrentItem()
            const buscador = document.getElementById('PickingSystemSearchUPC')
            if (buscador) {
                setTimeout(() => { buscador.focus(); }, 300);
            }
        }
    }

    async updateInv() {
        const data = {
            idCompany: Number(getValueCookie('CompanyId')),
            company: getValueCookie('Company'),
            idcompany: getValueCookie('CompanyId'),
        }
        const inventM = await getInformationWithData('/Items/get', data);
        this.setState({ Inventory: inventM.data })

    }

    async getActualOrders() {
        await this.handleModalOpen("showModal1")
        this.ModalLoading.current.showState(true);
        if (this.state.Inventory.length === 0) {
            await this.updateInv()
        }


        const data = {
            idcompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
            idCompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
            SalespersonNo: getValueCookie('SalesPerson'),
            Module:'Picking'
        }
        const data2 = {
            idcompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
            idCompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
            SalespersonNo: '0000'
        }
        var proccessInformation = []

        if (this.state.General.Mode === 'S/O') {
            const respuesta = await getInformationWithData('/sales/get/header', data);
            const completeList = await getInformationWithData('/sales/get/header/byDate', data2);


            if (respuesta.status.code === 1) {

                proccessInformation = respuesta.data.map((element) => {
                    const pos = getIndexElement(completeList.data, 'SalesOrderNo', element.SalesOrderNo)

                    return {
                        Status: element.Status ? element.Status : 0,
                        OrderNo: element.Comment ? element.SalesOrderNo + '-' + element.Comment : element.SalesOrderNo,
                        OrderName: element.BillToName,
                        Date: element.DateUpdated,
                        DateTime: decimalToHour(element.TimeCreated),
                        SalesPerson: element.SalespersonNo,
                        OrderNameAddress: element.BillToAddress1,
                        OrderNameCity: element.BillToCity,
                        OrderNameNo: element.CustomerNo,
                        PriceLevel: element.PriceLevel,
                        OrderType: element.OrderType,
                        Packing: element.Packing,
                        PosQue: pos !== -1 ? (completeList.data[pos].posicion ? (completeList.data[pos].posicion) : 999) : 999
                    }
                })
            }

            this.setState({ OrderHeaderList: proccessInformation, filteredOrderList: [...proccessInformation] });

        } else if (this.state.General.Mode === 'P/O') {
            const result = await getInformationWithData('/picklist/get/purchaseOrderHeader', data)

            if (result.status.code === 1) {


                proccessInformation = result.data.map((element) => {
                    return {
                        Status: element.Status,
                        OrderNo: element.Comment !== '' && this.state.General.Mode === 'P/O' ? element.OrderNo + '-' + element.Comment : element.OrderNo,
                        OrderName: element.OrderName,
                        Date: element.Date,
                        SalesPerson: element.SalesPerson,
                        OrderNameAddress: element.Address,
                        OrderNameCity: element.City,
                        OrderNameNo: element.OrderNameNo,
                        completionDate:element.completionDate
                    }
                }

                )
                this.setState({ OrderHeaderList: proccessInformation, filteredOrderList: [...proccessInformation] });
            }
        }
        this.ModalLoading.current.showState(false);

    }

    QueueSalesOrder(allInfo) {

    }

    // Get SO from backend and after load it in the UI
    async SelectOrderByNotification(notification) {
        const orderNo = notification.sales_order_no;

        // Verify changes in products
        const changedSOItems = JSON.parse(notification.changed_items_json || '[]');
        this.setState({changedSOItems: changedSOItems});
        // console.log(" - CHANGED SO - ");
        // console.log(changedSOItems);
        // console.log(" - CHANGED SO - ");

        // Set SO data
        const idCompany = Number(getValueCookie('CompanyId'));
        try {
            // Make request
            const res = await axios.post(`${server.url}/sales/get/header/by-no`, {
                data: { idCompany: idCompany, SalesOrderNo: orderNo, Module: 'Picking' }
            });

            if (res.data.status.code === 1) {
                let proccessInformation = [];
                const orders = res.data.data;
                // Append extra data
                proccessInformation = orders.map((element) => {
                    return {
                        Status: element.Status ? element.Status : 0,
                        OrderNo: element.Comment ? element.SalesOrderNo + '-' + element.Comment : element.SalesOrderNo,
                        OrderName: element.BillToName,
                        Date: element.DateUpdated,
                        DateTime: decimalToHour(element.TimeCreated),
                        SalesPerson: element.SalespersonNo,
                        OrderNameAddress: element.BillToAddress1,
                        OrderNameCity: element.BillToCity,
                        OrderNameNo: element.CustomerNo,
                        PriceLevel: element.PriceLevel,
                        OrderType: element.OrderType,
                        Packing: element.Packing,
                        PosQue: 999
                    }
                });
                // console.log(proccessInformation);
                
                // Load SO and update the UI
                if (proccessInformation && proccessInformation.length > 0) {
                    this.setState({ActualHeaderOrder: proccessInformation[0]});
                    this.SelectOrdertoPickUp(proccessInformation[0]);
                }
            } else {
                Swal.fire({title: `Wait`, text: `Order not found`, icon: 'warning', confirmButtonText: 'OK'});
            }
        } catch (error) {
            console.error('Error fetching Sales Order:', error);
            Swal.fire({title: `Wait`, text: `${error}`, icon: 'warning', confirmButtonText: 'OK'});
        }
    }

    async SelectOrdertoPickUp(order) {
        this.ModalLoading.current.showState(true);
        let OrderNo = order.OrderNo.split('-');

        const data = {
            SalesOrderNo: OrderNo[0],
            idCompany: Number(getValueCookie('CompanyId')),
            CustomerNo: order.OrderNameNo,
            username: getValueCookie('userName'),
            company: getValueCookie('Company'),
            idcompany: getValueCookie('CompanyId'),
        }

        if (this.state.General.Mode === 'S/O') {
            const customerInfo = await getInformationWithData('/customer/getByCustomerNo', data);
            const temporal = this.state.ActualHeaderOrder;
            // console.log('Temporal');
            // console.log(temporal);
            // console.log('customerInfo');
            // console.log(customerInfo);

            temporal.Status = order.Status;
            temporal.OrderNo = order.OrderNo;
            temporal.OrderName = order.OrderName + " - Level " + order.PriceLevel;
            temporal.OrderName2 = order.OrderName;
            temporal.OrderNameNo = order.OrderNameNo;
            temporal.OrderNameCity = order.OrderNameCity;
            temporal.Date = order.Date;
            temporal.SalesPerson = order.SalesPerson;
            temporal.OrderNameAddress = order.OrderNameAddress;
            temporal.Order = { ...order };
            temporal.Packing = order.Packing
            if (customerInfo.status.code === 1) {
                temporal.ZipCode = customerInfo.data[0].ZipCode || ''
                temporal.State = await this.getCustomerInfo('State', order.OrderNameNo)
            }
            this.setState({ ActualHeaderOrder: temporal })


            order.OrderNo = OrderNo[0];
            order.idCompany = Number(getValueCookie('CompanyId'));
            order.Mode = false
            if (!(order.Status)) {
                
                order.Status = 0
            }
            let result=null
            if(getValueCookie('CompanyId')!=='6'){
                result = await getInformationWithData('/sales/get/detail', order);
            }else{
                result = await getInformationWithData('/sales/get/detail/pickingAltitude', order);
            }


            if (result.status.code === 1) {   
                await result.data.Tabla1.forEach(element => {
                    const index = getIndexElement(this.state.Inventory, 'itemCode', element.ItemCode)
                    let desc = ''
                    if (index !== -1) {
                        desc = (!(this.state.Inventory[index].completeDesc) || this.state.Inventory[index].completeDesc === "null") ? this.state.Inventory[index].abbreviatedDesc : this.state.Inventory[index].completeDesc
                    }
                    if (desc !== '') {
                        element.ItemCodeDesc = desc
                    }
                });

                await result.data.Tabla2.forEach(element => {
                    const index = getIndexElement(this.state.Inventory, 'itemCode', element.ItemCode)
                    let desc = ''
                    if (index !== -1) {
                        desc = ((!(this.state.Inventory[index].completeDesc)) || this.state.Inventory[index].completeDesc === "null") ? this.state.Inventory[index].abbreviatedDesc : this.state.Inventory[index].completeDesc
                    }

                    if (desc !== '') {
                        element.ItemCodeDesc = desc
                    }
                });

                // Set colors to modified products
                const enrichedItems = result.data.Tabla1.map(item => {
                    const matchedChange = (this.state.changedSOItems || []).find(c => c.ItemCode === item.ItemCode);
                    return {
                        ...item,
                        change_type: matchedChange ? matchedChange.change_type : null
                    };
                });
                
                this.setState({ OrderDetailtoPick: enrichedItems, OrderDetailPicked: result.data.Tabla2 })
                // this.setState({ OrderDetailtoPick: result.data.Tabla1, OrderDetailPicked: result.data.Tabla2 })
                this.calculateTotals()
            } else {
                this.setState({ OrderDetailtoPick: [], OrderDetailPicked: [] })
            }
        } else if (this.state.General.Mode === 'P/O') {
            const result2 = await getInformationWithData('/picklist/get/purchaseOrderDetail', data)
            //const result3 = await getInformationWithData('/picklist/get/purchaseOrderDetail', data)

            if (result2.status.code === 1) {

                const temporal = this.state.ActualHeaderOrder
                temporal.Status = order.Status
                temporal.OrderNo = order.OrderNo
                temporal.OrderName = order.OrderName
                temporal.OrderName2 = order.OrderName
                temporal.OrderNameNo = order.OrderNameNo
                temporal.OrderNameCity = order.OrderNameCity
                temporal.Date = order.Date
                temporal.SalesPerson = order.SalesPerson
                temporal.OrderNameAddress = order.OrderNameAddress
                temporal.Order = order
                temporal.Packing = ''
                this.setState({ ActualHeaderOrder: temporal })
                await result2.data.Tabla1.forEach(element => {
                    const index = getIndexElement(this.state.Inventory, 'itemCode', element.ItemCode)
                    let desc = ''
                    if (index !== -1) {
                        desc = (!(this.state.Inventory[index].completeDesc) || this.state.Inventory[index].completeDesc === "null") ? this.state.Inventory[index].abbreviatedDesc : this.state.Inventory[index].completeDesc
                    }
                    if (desc !== '') {
                        element.ItemCodeDesc = desc
                    }
                });

                await result2.data.Tabla2.forEach(element => {
                    const index = getIndexElement(this.state.Inventory, 'itemCode', element.ItemCode)
                    let desc = ''
                    if (index !== -1) {
                        desc = ((!(this.state.Inventory[index].completeDesc)) || this.state.Inventory[index].completeDesc === "null") ? this.state.Inventory[index].abbreviatedDesc : this.state.Inventory[index].completeDesc
                    }

                    if (desc !== '') {
                        element.ItemCodeDesc = desc
                    }
                    element.receivedDate = FormatQueryReturnDateForReport(element.receivedDate)
                });

                this.setState({ OrderDetailtoPick: result2.data.Tabla1, OrderDetailPicked: result2.data.Tabla2 })
                this.calculateTotals();
            }
        }

        // Hide customer panel 
        let instance = this;
        setTimeout(() => {
            instance.setState({showCustomerTab: false});
        }, 2000);

        this.calculatePercentageScanning()
        this.handleModalClose("showModal1")
        this.ModalLoading.current.showState(false);
    }


    async UpdateOrderDetail(order,customerNo) {
        this.ModalLoading.current.showState(true);
        let OrderNo = order
        const data = {
            SalesOrderNo: OrderNo,
            idCompany: Number(getValueCookie('CompanyId')),
            CustomerNo: customerNo,
            username: getValueCookie('userName'),
            company: getValueCookie('Company'),
            idcompany: getValueCookie('CompanyId'),

        }




        if (this.state.General.Mode === 'S/O') {
            const customerInfo = await getInformationWithData('/customer/getByCustomerNo', data)
            const temporal = this.state.ActualHeaderOrder
            temporal.Status = order.Status
            temporal.OrderNo = order.OrderNo
            temporal.OrderName = order.OrderName + " - Level " + order.PriceLevel
            temporal.OrderName2 = order.OrderName
            temporal.OrderNameNo = order.OrderNameNo
            temporal.OrderNameCity = order.OrderNameCity
            temporal.Date = order.Date
            temporal.SalesPerson = order.SalesPerson
            temporal.OrderNameAddress = order.OrderNameAddress
            temporal.Order = order
            temporal.Packing = order.Packing
            if (customerInfo.status.code === 1) {
                temporal.ZipCode = customerInfo.data[0].ZipCode
                temporal.State = await this.getCustomerInfo('State', order.OrderNameNo)
            }





            await this.setState({ ActualHeaderOrder: temporal })


            order.OrderNo = OrderNo[0];
            order.idCompany = Number(getValueCookie('CompanyId'));
            order.Mode = false
            if (!(order.Status)) {
                order.Status = 0
            }
            const result = await getInformationWithData('/sales/get/detail', order)

            if (result.status.code === 1) {

                await result.data.Tabla1.forEach(element => {
                    const index = getIndexElement(this.state.Inventory, 'itemCode', element.ItemCode)
                    let desc = ''
                    if (index !== -1) {
                        desc = (!(this.state.Inventory[index].completeDesc) || this.state.Inventory[index].completeDesc === "null") ? this.state.Inventory[index].abbreviatedDesc : this.state.Inventory[index].completeDesc
                    }
                    if (desc !== '') {
                        element.ItemCodeDesc = desc
                    }
                });

                await result.data.Tabla2.forEach(element => {
                    const index = getIndexElement(this.state.Inventory, 'itemCode', element.ItemCode)
                    let desc = ''
                    if (index !== -1) {
                        desc = ((!(this.state.Inventory[index].completeDesc)) || this.state.Inventory[index].completeDesc === "null") ? this.state.Inventory[index].abbreviatedDesc : this.state.Inventory[index].completeDesc
                    }

                    if (desc !== '') {
                        element.ItemCodeDesc = desc
                    }
                });

                this.setState({ OrderDetailtoPick: result.data.Tabla1, OrderDetailPicked: result.data.Tabla2 })
                this.calculateTotals()
            } else {
                this.setState({ OrderDetailtoPick: [], OrderDetailPicked: [] })
            }



        } else if (this.state.General.Mode === 'P/O') {
            const result2 = await getInformationWithData('/picklist/get/purchaseOrderDetail', data)
            //const result3 = await getInformationWithData('/picklist/get/purchaseOrderDetail', data)

            if (result2.status.code === 1) {

                const temporal = this.state.ActualHeaderOrder
                temporal.Status = order.Status
                temporal.OrderNo = order.OrderNo
                temporal.OrderName = order.OrderName
                temporal.OrderName2 = order.OrderName
                temporal.OrderNameNo = order.OrderNameNo
                temporal.OrderNameCity = order.OrderNameCity
                temporal.Date = order.Date
                temporal.SalesPerson = order.SalesPerson
                temporal.OrderNameAddress = order.OrderNameAddress
                temporal.Order = order
                temporal.Packing = ''
                this.setState({ ActualHeaderOrder: temporal })
                await result2.data.Tabla1.forEach(element => {
                    const index = getIndexElement(this.state.Inventory, 'itemCode', element.ItemCode)
                    let desc = ''
                    if (index !== -1) {
                        desc = (!(this.state.Inventory[index].completeDesc) || this.state.Inventory[index].completeDesc === "null") ? this.state.Inventory[index].abbreviatedDesc : this.state.Inventory[index].completeDesc
                    }
                    if (desc !== '') {
                        element.ItemCodeDesc = desc
                    }
                });

                await result2.data.Tabla2.forEach(element => {
                    const index = getIndexElement(this.state.Inventory, 'itemCode', element.ItemCode)
                    let desc = ''
                    if (index !== -1) {
                        desc = ((!(this.state.Inventory[index].completeDesc)) || this.state.Inventory[index].completeDesc === "null") ? this.state.Inventory[index].abbreviatedDesc : this.state.Inventory[index].completeDesc
                    }

                    if (desc !== '') {
                        element.ItemCodeDesc = desc
                    }
                    element.receivedDate = FormatQueryReturnDateForReport(element.receivedDate)
                });

                this.setState({ OrderDetailtoPick: result2.data.Tabla1, OrderDetailPicked: result2.data.Tabla2 })
                this.calculateTotals()




            }
        }

        




        this.calculatePercentageScanning()
        this.handleModalClose("showModal1")
        this.ModalLoading.current.showState(false);
    }

    async PickItem(Item, add) {
        // Validate if it was deleted
        if (Item.change_type !== 'deleted') {
            if (Number(this.state.ActualHeaderOrder.Status) !== 2||this.state.ActualHeaderOrder.SalesPerson!=='WW') {
    
                this.handleModalOpen("showModal2")
                const data = {
                    ItemCode: Item.ItemCode,
                    BIN: Item.BIN,
                    company: getValueCookie('Company'),
                    idCompany: Number(getValueCookie('CompanyId')),
                }
                const data2 = {
                    ItemCode: Item.ItemCode,
                    BIN: Item.BIN,
                    company: getValueCookie('Company'),
                    idCompany: (getValueCookie('CompanyId')),
                }
    
                const resultquant = await getInformationWithData('/invertory/getQuantity/post', data2)
                const resultImg = await getInformationWithData('/Items/get/Img', data)
                if (resultquant.status.code === 1 && resultImg.status.code === 1) {
                    var URL = ''
                    if (resultImg.status.code === 1) {
                        if (resultImg.data.itemURLImage && resultImg.data.itemURLImage !== '') {
                            const date = new Date().getTime()
                            URL = `${resultImg.data.itemURLImage}?${date}`
                        } else {
                            URL = null
                        }
                    }
                    let onHand = 0
                    if (resultquant.data.length > 0) {
                        onHand = resultquant.data[0].Quantity.toFixed(0)
                    }
    
                    const ItemSelected = {
                        ItemCode: Item.ItemCode,
                        Description: Item.ItemCodeDesc,
                        onHand: onHand,
                        QuantityOrdered: Item.QuantityOrdered,
                        QuantityShipRec: add ? 1 : 0,
                        BIN: Item.BIN,
                        Pallet: '01',
                        UnitPrice: Item.UnitPrice,
                        ImgURL: URL,
                        RegisterType: Item.RegisterType ? Item.RegisterType : 'm',
                        HaveUPC: ((resultImg.data.upc) || (resultImg.data.upc2) || (resultImg.data.caseupc)) ? true : false,
                        DueDate: null
                    }
    
                    let input = document.getElementById('quantityShipRecPickingSystem')
                    if (input) {
                        input.value = ItemSelected.QuantityShipRec > 0 ? ItemSelected.QuantityShipRec : 0
                    }
    
    
    
                    this.setState({ CurrentItem: ItemSelected })
    
                }
            }else{
                confirmCloseAlert('incorrect','This order are finished, please contact with the Warehouse Admin!')
            }
        }
    }
    clearCurrentItem() {
        const ItemSelected = {
            ItemCode: '',
            Description: '',
            onHand: 0,
            QuantityOrdered: 0,
            QuantityShipRec: 0,
            BIN: '',
            Pallet: '01',
            UnitPrice: '',
            ImgURL: '',
            RegisterType: '',
            DueDate: null
        }
        this.setState({ CurrentItem: ItemSelected })
    }
    calculatePercentageScanning() {
        let total = 0

        let manual = 0
        let scanner = 0
        for (const item of this.state.OrderDetailPicked) {

            if (item.QuantityShipped > 0) {
                total += 1
                if (item.RegisterType === 's') {
                    scanner += 1
                } else {
                    manual += 1
                }
            }

        }
        if (total > 0) {
            let Pmanual = 100 * (manual / total)
            let Pscanning = 100 * (scanner / total)
            this.setState({ TotalManual: manual, TotalScanning: scanner, PercentageManual: Pmanual, PercentageScanning: Pscanning })
        } else {
            this.setState({ TotalManual: 0, TotalScanning: 0, PercentageManual: 0, PercentageScanning: 0 })
        }
    }

    async confirmPickItem() {
        let orderno = this.state.ActualHeaderOrder.OrderNo.split('-')
        const temporal = this.state.CurrentItem
        const index = getIndexElement(this.state.OrderDetailtoPick, "ItemCode", temporal.ItemCode)
        if (index !== -1) {
            const itemToPick = this.state.OrderDetailtoPick[index]

            itemToPick.QuantityShipped = Number(document.getElementById('quantityShipRecPickingSystem').value)
            itemToPick.Pallet = this.state.General.currentPallet
            itemToPick.check = 1
            itemToPick.UserName = getValueCookie('userName')
            itemToPick.receivedDate = FormatQueryReturnDateForReport(getActualDateUTC())
            itemToPick.TotalLineWeight = Number(document.getElementById('quantityShipRecPickingSystem').value) * Number(itemToPick.LineWeight)
            itemToPick.HaveUPC = temporal.HaveUPC
            itemToPick.RegisterType = temporal.RegisterType
            const Table1 = this.state.OrderDetailtoPick
            const Table2 = this.state.OrderDetailPicked


            const data = {
                OrderNo: orderno[0],
                IdCompany:Number(getValueCookie('CompanyId')),
                ItemCode: itemToPick.ItemCode,
                QuantityRecived: Number(document.getElementById('quantityShipRecPickingSystem').value),
                QuantityShipped: Number(document.getElementById('quantityShipRecPickingSystem').value),
                Pallet: document.getElementById('palletPickingSystem').value,
                User: getValueCookie('userName'),
                DispatchDate: getActualDateUTC(),
                check: 1,
                Mode: this.state.General.Mode,
                QuantityOrdered: temporal.QuantityOrdered,
                UnitPrice: temporal.UnitPrice,
                UnitCost: itemToPick.LastTotalUnitCost,
                ItemCodeDesc: DeleteStrangeCharacter(itemToPick.ItemCodeDesc),
                LineWeight: itemToPick.LineWeight,
                RegisterType: temporal.RegisterType,
                HaveUPC: temporal.HaveUPC,
                DueDate: temporal.DueDate?this.formatDate(temporal.DueDate):temporal.DueDate
            }
            if (this.state.General.Mode === 'S/O') {
                if (data.QuantityShipped > 0 && !data.HaveUPC) {
                    data.RegisterType = 's'
                    itemToPick.RegisterType = 's'
                }
            } else {
                if (data.QuantityRecived > 0 && !data.HaveUPC) {
                    data.RegisterType = 's'
                    itemToPick.RegisterType = 's'
                }
            }

           
            if ((this.state.CurrentItem.DueDate||data.QuantityRecived===0) || this.state.General.Mode === 'S/O') {
                const result = await create_Delete_Update_Information('/picklist/set/dispatchItem', data)

                if (result.status.code !== 1) {
                    await this.handleModalClose("showModal2");
                    await confirmCloseAlert('incorrect', 'Whoops we have an error. Please try again!');
                    await this.SelectOrdertoPickUp(this.state.ActualHeaderOrder.Order);

                } else {
                    Table1.splice(index, 1)
                    Table2.push(itemToPick)
                    this.setState({ OrderDetailPicked: Table2, OrderDetailtoPick: Table1 })
                    await this.handleModalClose("showModal2")

                }
            } else {
                confirmCloseAlert('incorrect','You need put the Fecha de Vencimiento!')
            }



        } else {

            const newItem = {
                BIN: this.state.CurrentItem.BIN,
                CASEUPC: 0,
                CommetText: '',
                ItemCode: this.state.CurrentItem.ItemCode,
                ItemCodeDesc: this.state.CurrentItem.Description,
                LineSeqNo: 0,
                LineWeight: '',
                OrderNo: orderno[0],
                Pallet: document.getElementById('palletPickingSystem').value,
                QuantityOrdered: 0,
                QuantityShipped: Number(document.getElementById('quantityShipRecPickingSystem').value),
                UPC: '',
                caseupc: 0,
                check: 1,
                RegisterType: this.state.CurrentItem.RegisterType,
                HaveUPC: this.state.CurrentItem.HaveUPC,
                DueDate: this.state.CurrentItem.DueDate
            }
            if (this.state.General.Mode === 'S/O') {
                if (newItem.QuantityShipped > 0 && !newItem.HaveUPC) {
                    newItem.RegisterType = 's'
                }
            } else {
                if (newItem.QuantityRecived > 0 && !newItem.HaveUPC) {
                    newItem.RegisterType = 's'
                }
            }

            const Table2 = this.state.OrderDetailPicked
            Table2.push(newItem)
            this.setState({ OrderDetailPicked: Table2 })
            this.handleModalClose("showModal2")
        }


        this.calculateTotals()
        this.calculatePercentageScanning()
        const buscador = document.getElementById('PickingSystemSearchUPC')
        if (buscador) {
            setTimeout(() => { buscador.focus(); }, 300);
        }

    }

    async RemoveProductPickedList(temporal) {

        if (Number(this.state.ActualHeaderOrder.Status) !== 2||this.state.ActualHeaderOrder.SalesPerson!=='WW') {
            Swal.fire({
                title: 'Are you sure?',
                text: "You are removing a product to the Picked Up List",
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                showCancelButton: true,
                confirmButtonText: 'Yes, remove',
                cancelButtonText: 'No, cancel!',
            }).then(async (result) => {
                if (result.isConfirmed) {


                    const index = getIndexElement(this.state.OrderDetailPicked, "ItemCode", temporal.ItemCode)
                    if (index !== -1) {

                        const itemToPick = this.state.OrderDetailPicked[index]

                        itemToPick.QuantityShipped = 0
                        itemToPick.Pallet = '01'
                        itemToPick.check = 0
                        itemToPick.HaveUPC = false
                        itemToPick.RegisterType = ''
                        const Table1 = this.state.OrderDetailtoPick
                        const Table2 = this.state.OrderDetailPicked
                        Table2.splice(index, 1)
                        Table1.push(itemToPick)
                        this.setState({ OrderDetailPicked: Table2, OrderDetailtoPick: Table1 })
                        if (this.state.General.Mode === 'S/O') {
                            const data = {
                                OrderNo: temporal.SalesOrderNo,
                                ItemCode: itemToPick.ItemCode,
                                QuantityRecived: 0,
                                Pallet: '',
                                User: '',
                                DispatchDate: new Date(),
                                check: 0,
                                Mode: this.state.General.Mode,
                            }
                            await create_Delete_Update_Information('/picklist/set/dispatchItem', data)
                        } else {
                            let orderno = this.state.ActualHeaderOrder.OrderNo.split('-')
                            const data = {
                                OrderNo: temporal.OrderNo ? temporal.OrderNo : orderno[0],
                                ItemCode: itemToPick.ItemCode,
                                QuantityRecived: 0,
                                Pallet: '01',
                                User: '',
                                DispatchDate: '000-00-00 00:00:00',
                                check: 0,
                                Mode: this.state.General.Mode,
                            }

                            await create_Delete_Update_Information('/picklist/set/dispatchItem', data)
                        }




                    }
                    this.calculateTotals()
                }
            })
        }else{
            confirmCloseAlert('incorrect','This order are finished, please contact with the Warehouse Admin!')
        }

    }
    print() {

    }

    clearTotals() {
        const temporal = this.state.Totals
        temporal.OrderDetailtoPick.QuantityOrdered = 0
        temporal.OrderDetailtoPick.TotalWeight = 0

        temporal.OrderDetailPicked.QuantityOrdered = 0
        temporal.OrderDetailPicked.QuantityShipRec = 0
        temporal.OrderDetailPicked.TotalWeight = 0

        this.setState({ Totals: temporal })
    }

    calculateTotals() {
        const temporal = this.state.Totals
        this.clearTotals()
        for (const item of this.state.OrderDetailtoPick) {

            temporal.OrderDetailtoPick.QuantityOrdered += Number(item.QuantityOrdered)
            temporal.OrderDetailtoPick.TotalWeight += Number(item.QuantityOrdered) * Number(item.LineWeight)


        }
        for (const item of this.state.OrderDetailPicked) {
            if (item.Pallet !== -1) {
                if (item.LineSeqNo || this.state.General.Mode === 'P/O') {
                    temporal.OrderDetailPicked.QuantityOrdered += Number(item.QuantityOrdered)
                    temporal.OrderDetailPicked.QuantityShipRec += Number(item.QuantityShipped)
                    temporal.OrderDetailPicked.TotalWeight += Number(item.QuantityShipped) * Number(item.LineWeight)
                }
            }
        }
        this.setState({ Totals: temporal })
    }

    confirmCompletePick() {
        Swal.fire({
            title: 'Are you sure to complete this order?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, I\'m sure!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                let orderno = this.state.ActualHeaderOrder.OrderNo.split('-')
                if(this.state.General.Mode==='P/O'){
                    await this.UpdateOrderDetail(orderno, this.state.ActualHeaderOrder.OrderNameNo)
                }

                this.calculatePercentageScanning()
                
                const data = {
                    OrderNo: orderno[0],
                    Status: '2',
                    idCompany: getValueCookie('CompanyId'),
                    MODE: this.state.General.Mode
                }
                const resultSql = await create_Delete_Update_Information('/picklist/set/PickListState', data)
                await getInformationWithDataGlobalSales('/Sales/setStatus',{SalesOrderNo: data.OrderNo,OrderStatus: 6})
                if (resultSql.code === 1) {
                    const temporal = this.state.ActualHeaderOrder
                    temporal.Status = '2'
                    this.setState({ ActualHeaderOrder: temporal })
                    Swal.fire({
                        title: 'Order Completed!',
                        html: `
                        <div className='tableFixHead'>
                        <table className='table align-middle'>
                        <thead className='thead'>
                            <tr className='text-light text-center'>
                                <th className='bg-dark'>Type</th>
                                <th className='bg-dark'>Quantity</th>
                                <th className='bg-dark'>Percentage</th>
                            </tr>
                        </thead>
                        <tbody className='tbody'>
                            <tr>
                            <td>Scanned Products</td>
                            <td>${this.state.TotalScanning}</td>
                            <td className='text-end'>${pricesFormat(this.state.PercentageScanning)} %</td>
                            </tr>
                            <tr>
                            <td>Manual Products</td>
                            <td>${this.state.TotalManual}</td>
                            <td className='text-end'>${pricesFormat(this.state.PercentageManual)}%</td>
                            </tr>
                        </tbody>
                        <tfoot className='tfoot'>
                        <tr className='bg-secondary text-light'>
                        <td>Total</td>
                        <td>${this.state.TotalManual + this.state.TotalScanning}</td>
                        <td>${100} %</td>
                        </tr>
                        </tfoot>
                    </table>
                            </div>
                            <div className=''>
                        <p>The order was registered.\nWould you like print it?</p>
                        </div>
                            `,
                        icon: 'success',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, please!',
                        cancelButtonText: 'No thanks'
                    }
                    ).then((result) => {
                        if (result.isConfirmed) {
                            var button = document.getElementById('PrintPickOrder')
                            if (button) {
                                button.click()
                            }
                        } else {
                            this.clearAll()
                        }
                    })
                }


            }
        })
    }

    stateInWords(state) {

        if (this.state.General.Mode === 'P/O') {
            if (state === '1') {
                return 'Pending Order'
            } else if (state === '2') {
                return 'Order Completed'
            } else {
                return ''
            }
        } else {
            if (state === 1) {
                return 'In process'
            } else if (state === 2) {
                return 'Finished'
            } else {
                return 'Not started'
            }
        }



    }
    stateClassColor(state) {
        if (this.state.General.Mode === 'P/O') {
            if (state === '1') {
                return 'yellow'
            } else if (state === '2') {
                return 'green'
            } else {
                return ''
            }
        } else {
            if (state === 1) {
                return 'yellow'
            } else if (state === 2) {
                return 'green'
            } else {
                return 'red'
            }
        }
    }

    statusIcon(state, mode) {
        const normalizedMode = mode || ''; 

        if (normalizedMode === 'P/O') {
            if (state === '1') {
                return <AiOutlineClockCircle color="#212121" title="Process" />;
            } else if (state === '2') {
                return <AiOutlineCheckCircle color="#fff" title="Finished" />;
            } else {
                return null;
            }
        } else {
            if (state === 1) {
                return <AiOutlineClockCircle color="#212121" title="Process" />;
            } else if (state === 2) {
                return <AiOutlineCheckCircle color="#fff" title="Finished" />;
            } else {
                return <AiOutlineCloseCircle color="#fff" title="Not started" />;
            }
        }
    }

    formatDatePickedUp() {
        let temporal = []
        let copy = JSON.parse(JSON.stringify(this.state.OrderDetailPicked))
        copy.forEach(element => {
            element.receivedDate2 = element.receivedDate
            element.QuantityOrdered = NumberFormat(pricesFormat(element.QuantityOrdered))
            element.QuantityShipped = NumberFormat(pricesFormat(element.QuantityShipped))
            element.LineWeight = NumberFormat(pricesFormat(Number(element.LineWeight)))
            element.TotalLineWeight = Number(element.TotalLineWeight)
            if (element.Pallet !== -1) {
                if (element.LineSeqNo) {
                    temporal.push(element)
                }

            }

        });
        return temporal
    }

    ordenar(arreglo, llave, bandera) {

        const l = arreglo.length;
        if (bandera) {
            for (let i = 0; i < l; i++) {
                for (let j = 0; j < l - 1 - i; j++) {
                    if (arreglo[j][llave] > arreglo[j + 1][llave]) {
                        [arreglo[j], arreglo[j + 1]] = [arreglo[j + 1], arreglo[j]];
                    }
                }
            }
        } else {
            for (let i = 0; i < l; i++) {
                for (let j = 0; j < l - 1 - i; j++) {
                    if (arreglo[j][llave] < arreglo[j + 1][llave]) {
                        [arreglo[j], arreglo[j + 1]] = [arreglo[j + 1], arreglo[j]];
                    }
                }
            }
        }
        return arreglo;
    }


    arreglarLista(llave) {
        let pick = this.state.OrderDetailtoPick
        pick = this.ordenar(pick, llave, this.state.bandera);
        this.setState({ bandera: !this.state.bandera });
        this.setState({ OrderDetailtoPick: pick });
    }

    arreglarLista2(llave) {
        let pick = this.state.OrderDetailPicked
        pick = this.ordenar(pick, llave, this.state.bandera);
        this.setState({ bandera: !this.state.bandera });
        this.setState({ OrderDetailPicked: pick });
    }

    onTarget = e => {
        const id = e.target.id
        if (id === 'palletPickingSystem') {
            const temporal = this.state.General
            temporal.currentPallet = e.target.value
            this.setState({ General: temporal })
        }
    }

    async getCustomerInfo(key, customerNo) {
        const data = {
            idCompany: Number(getValueCookie('CompanyId')),
            CustomerNo: customerNo,
        }
        const result = await getInformationWithData('/customer/getByCustomerNo', data);
        if (result.status.code === 1) {
            if (result.data.length > 0) {
                return result.data[0][key]
            }
        }
        return ''
    }
    GeneralOrder(key, asc, name) {
        const temporal = this.state[name]
        const Order = OrderArray(temporal, key, asc)

        this.setState({ [name]: Order, order: !asc })
    }
    changeInputShipped = (e) => {
        let quant = Number(e.target.value)

        if (!validateNumbersForQuantitys(quant)) {
            let parteDecimal = 1 - DecimalPart(quant)
            quant += parteDecimal
            document.getElementById(e.target.id).value = quant
        }
    }
    changeDueDate = (e) => {
        const temporal = this.state.CurrentItem
        let date = new Date(e.target.value)
        temporal.DueDate = new Date(date.setMinutes(date.getMinutes() + date.getTimezoneOffset()))
    }
    formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    handleSearchOrders = () => {
        const pattern = this.state.searchText.trim();
        if (!pattern) {
            // Vacío = mostrar todo
            this.setState({ filteredOrderList: [...this.state.OrderHeaderList] });
            return;
        }

        try {
            const regex = new RegExp(pattern, 'i');

            const filtered = this.state.OrderHeaderList.filter(order =>
            regex.test(order.OrderNo) ||
            regex.test(order.OrderName) ||
            regex.test(order.SalesPerson)
            );

            this.setState({ filteredOrderList: filtered });
        } catch (e) {
            console.warn("Expresión inválida:", pattern);
            // Si el regex falla, no hacer nada
        }
    };

    render() {
        return (
            <div>
                {/* Loading */}
                <LoadingWindow ref={this.ModalLoading} />

                {/* Notifications */}
                <NotificationBell openSO={this.SelectOrderByNotification.bind(this)} selectedSO={this.state.ActualHeaderOrder} />

                {/* Hero */}
                <div className='text-center my-4'>
                    <h2 className='display-5 fw-bold inventory-title'>Picking System</h2>
                    <p className='lead text-muted inventory-subtitle'>Select a sales order.</p>
                </div>

                <div className='row d-flex justify-content-center pb-4'>
                    <div className='col-md-10 InputText'>
                        <div className="card shadow">
                            <div className="card-body">
                                <div className="input-group input-group-lg flex-nowrap" style={{ marginBottom: 0 }}>
                                    <input type="text" autoComplete='off' className="form-control inputResize" disabled value={this.state.ActualHeaderOrder.OrderNo} id='OrderNoPickingSystem' onClick={() => this.getActualOrders()} />
                                    
                                    <button type="button" className={"button " + this.state.General.Colorclass + " btn-lg"} style={{ fontWeight: 'normal', fontSize: '1rem', paddingLeft: 35, paddingRight: 35 }} onClick={() => this.changeMode()}>{this.state.General.Mode + " Mode"}</button>

                                    <button type="button" className="btn blueButton btn-lg shadow" onClick={() => this.getActualOrders()}><AiOutlineSearch /></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Show customer only when SO is selected */}
                {this.state.ActualHeaderOrder && this.state.ActualHeaderOrder.OrderName && this.state.showCustomerTab ? 
                    <div className='row d-flex justify-content-center pb-4'>
                        <div className='col-md-10'>
                            <div className="card">
                                <div className="card-body" style={{ backgroundColor: '#e9ecef' }}>
                                    <div className="row">
                                        <div className='d-flex justify-content-between align-items-center' style={{ width: '100%' }}>
                                            <h5 className='darkPurpleText'>Customer</h5>

                                            <button type="button" className="btn btn-lg shadow darkPurpleBackground" onClick={() => this.setState({showCustomerTab: false})}>
                                                <AiOutlineMinusSquare size={16} title="Ocultar" />
                                            </button>
                                        </div>
                                    </div>

                                    <hr />

                                    <div className='row mt-4'>
                                        <div className='col-sm-6'>
                                            <div className='row'>
                                                <div className='col-12 InputText'>
                                                    <p>Name</p>
                                                </div>
                                                <div className='col-12 pb-3'>
                                                    <div className="input-group input-group-lg">
                                                        <input disabled type="text" autoComplete='off' value={this.state.ActualHeaderOrder.OrderName.replace('null', '')} className="form-control" id='orderNamePickingSystem' />
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                        <div className='col-sm-6'>
                                            <div className='row'>
                                                <div className='col-12 InputText'>
                                                    <p>Order by</p>
                                                </div>
                                                <div className='col-12 pb-3'>
                                                    <div className="input-group input-group-lg">
                                                        <input disabled type="text" autoComplete='off' value={this.state.ActualHeaderOrder.SalesPerson} className="form-control" id='salesPersonPickingSystem' />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-sm-12'>
                                            <div className='row'>
                                                <div className='col-12 InputText'>
                                                    <p>Comment</p>
                                                </div>
                                                <div className='col-12 pb-1'>
                                                    <div className="input-group input-group-lg pb-4 textAreaGeneral">
                                                        <textarea disabled={this.state.ActualHeaderOrder.OrderNo === '' || this.state.ActualHeaderOrder.Status === '2'} className="form-control" id="exampleFormControlTextarea1" placeholder='Insert comment...' rows="3"></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-sm-12' hidden={this.state.General.Mode === 'P/O'}>
                                            <div className='row'>
                                                <div className='col-12 InputText'>
                                                    <p>Type of Packing</p>
                                                </div>
                                                <div className='col-12 pb-1'>
                                                    <div className='input-group input-group-lg'>
                                                        <input disabled type="text" autoComplete='off' value={ReplaceCharacter(this.state.ActualHeaderOrder.Packing && this.state.ActualHeaderOrder.Packing !== 'null;null' ? this.state.ActualHeaderOrder.Packing : '',';',' ')} className="form-control" id='typeOfPackingPickingSystem' />

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                : null }
                {this.state.ActualHeaderOrder && this.state.ActualHeaderOrder.OrderName && !this.state.showCustomerTab ? 
                    <div className='row d-flex justify-content-center pb-4'>
                        <div className='col-md-10'>
                            <div className="card shadow">
                                <div className="card-body" style={{ padding: '1rem' }}>
                                    <div className='d-flex justify-content-between align-items-center' style={{ width: '100%' }}>
                                        <h5 className='mb-0 darkPurpleText'>Customer</h5>

                                        <button type="button" className="btn btn-lg shadow darkPurpleBackground" onClick={() => this.setState({showCustomerTab: true})}>
                                            <AiOutlineZoomIn size={16} title="Expandir" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                : null}

                
                {/* Picking List Sales Order section */}
                {this.state.ActualHeaderOrder && this.state.ActualHeaderOrder.OrderName ? 
                    <div className='row d-flex justify-content-center pb-4'>
                        <div className='col-md-10'>
                            <div className="card shadow">
                                <div className="card-body">

                                    {/* Title */}
                                    {/* this.state.General.Colorclass */}
                                    <p className={'p-2 fs-3 text-center button darkPurpleText'}>{"Picking List " + this.state.General.ModeTitle}</p>

                                    {/* Search */}
                                    <div className='row pb-3'>
                                        <div className='col-sm-12'>
                                            <div hidden={this.state.General.Mode === 'S/O'}>
                                                <Catalogue Array={'OrderDetailtoPick'} disabled={this.state.ActualHeaderOrder.Status === '2'} nombrePadre={"PickingSystem"} Padre={this} />
                                            </div>
                                        </div>
                                        <SearchUPC id={"PickingSystemSearchUPC"} ComponentName={'PickingSystem'} Padre={this} />
                                    </div>
                                    {/* <div className="input-group input-group-lg flex-nowrap" style={{ marginBottom: 0 }}>
                                        <input type="text" autoComplete='off' className="form-control inputResize" disabled value={this.state.ActualHeaderOrder.OrderNo} id='OrderNoPickingSystem' />

                                        <button type="button" className="btn blueButton btn-lg shadow" onClick={() => this.getActualOrders()}><AiOutlineSearch /></button>
                                    </div> */}

                                    <div className='tableFixHead tb-1'>
                                        <table className='table table-striped align-middle'>
                                            <thead>
                                                <tr className='text-center'>
                                                    <th onClick={() => this.arreglarLista('LineSeqNo')} hidden> 
                                                        <div className='d-flex justify-content-center align-items-center'>
                                                            Line Key
                                                            <div className='ms-2'>
                                                                <BsFileArrowUpFill /> <BsFileArrowDownFill />
                                                            </div>
                                                        </div>
                                                    </th>
                                                    <th onClick={() => this.arreglarLista('ItemCode')}>
                                                        <div className='d-flex justify-content-center align-items-center'>
                                                            Item Code
                                                            <div className='ms-2'>
                                                                <BsFileArrowUpFill /> <BsFileArrowDownFill />
                                                            </div>
                                                        </div>
                                                    </th>
                                                    <th>Description</th>
                                                    <th onClick={() => this.arreglarLista('QuantityOrdered')}>
                                                        <div className='d-flex justify-content-center align-items-center'>
                                                            Quantity Ordered
                                                            <div className='ms-2'>
                                                                <BsFileArrowUpFill /> <BsFileArrowDownFill />
                                                            </div>
                                                        </div>
                                                    </th>
                                                    <th onClick={() => this.arreglarLista('LineWeight')}>
                                                        <div className='d-flex justify-content-center align-items-center'>
                                                            Weight
                                                            <div className='ms-2'>
                                                                <BsFileArrowUpFill /> <BsFileArrowDownFill />
                                                            </div>
                                                        </div>
                                                    </th>
                                                    <th onClick={() => this.arreglarLista('TotalWeight')}>
                                                        <div className='d-flex justify-content-center align-items-center'>
                                                            Total Weight
                                                            <div className='ms-2'>
                                                                <BsFileArrowUpFill /> <BsFileArrowDownFill />
                                                            </div>
                                                        </div>
                                                    </th>
                                                    <th hidden>BIN</th>
                                                    <th>Comments</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {this.state.OrderDetailtoPick.map((item, i) => {
                                                let rowStyle = {};
                                                if (item.change_type === 'added') rowStyle.backgroundColor = '#d4edda'; // verde claro
                                                if (item.change_type === 'modified') rowStyle.backgroundColor = '#fff3cd'; // amarillo claro
                                                if (item.change_type === 'deleted') rowStyle.backgroundColor = '#f8d7da'; // rojo claro

                                                return (
                                                    <tr onClick={() => this.PickItem(item, false)} key={i} style={rowStyle}>
                                                        <td hidden style={{ paddingTop: 20, paddingBottom: 20 }}>
                                                            {item.LineSeqNo}
                                                        </td>
                                                        <td style={{ paddingTop: 20, paddingBottom: 20 }}>
                                                            <div className='badge blueLightBackground'>{item.ItemCode}</div>
                                                        </td>
                                                        <td style={{ paddingTop: 20, paddingBottom: 20 }}>
                                                            {item.ItemCodeDesc}

                                                            {/* Show deleted badge */}
                                                            {item.change_type === 'deleted' ? 
                                                                <p className='badge redBackground'>Item deleted</p>
                                                            : null}
                                                        </td>
                                                        <td className='text-center' style={{ paddingTop: 20, paddingBottom: 20 }}>
                                                            {item.QuantityOrdered}
                                                        </td>
                                                        <td className='text-center' style={{ paddingTop: 20, paddingBottom: 20 }}>
                                                            {item.LineWeight}
                                                        </td>
                                                        <td className='text-center' style={{ paddingTop: 20, paddingBottom: 20 }}>
                                                            {item.TotalWeight ? item.TotalWeight : Number(item.LineWeight) * Number(item.QuantityOrdered)}
                                                        </td>
                                                        <td hidden className='text-center' style={{ paddingTop: 20, paddingBottom: 20 }}>
                                                            {item.BIN}
                                                        </td>
                                                        <td className='text-start' style={{ paddingTop: 20, paddingBottom: 20 }}>
                                                            {item.CommentText}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                            </tbody>
                                            <tfoot className='tfoot'>
                                                <tr className='text-light text-center darkPurpleBackground'>
                                                    <td></td>
                                                    <td>Totals</td>
                                                    <td>{this.state.Totals.OrderDetailtoPick.QuantityOrdered}</td>
                                                    <td></td>
                                                    <td>{this.state.Totals.OrderDetailtoPick.TotalWeight.toFixed(2)}</td>
                                                    <td hidden></td>
                                                    <td></td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                : null}


                {/* Pickedup section */}
                {this.state.ActualHeaderOrder && this.state.ActualHeaderOrder.OrderName ? 
                    <div className='row d-flex justify-content-center pb-4'>
                        <div className='col-md-10'>
                            <div className="card shadow">
                                <div className="card-body">

                                    <div className='col-sm-12'>
                                        <p className={'p-2 fs-3 text-center button darkPurpleText'}>Picked up List</p>
                                    </div>

                                    <div className='col-sm-12'>
                                        <div className='col-12 tableFixHead tb-1'>
                                            <table className='table table-striped align-middle'>
                                                <thead>
                                                    <tr className='text-center'>
                                                        <th onClick={() => this.arreglarLista2('LineSeqNo')}>
                                                            <div className='d-flex justify-content-center align-items-center'>
                                                                Line Seq.
                                                                <div className='ms-2'>
                                                                    <BsFileArrowUpFill /> <BsFileArrowDownFill />
                                                                </div>
                                                            </div>
                                                        </th>
                                                        <th onClick={() => this.arreglarLista2('ItemCode')}>
                                                            <div className='d-flex justify-content-center align-items-center'>
                                                                Item Code
                                                                <div className='ms-2'>
                                                                    <BsFileArrowUpFill /> <BsFileArrowDownFill />
                                                                </div>
                                                            </div>
                                                        </th>
                                                        <th>Description</th>
                                                        <th onClick={() => this.arreglarLista2('QuantityOrdered')}>
                                                            <div className='d-flex justify-content-center align-items-center'>
                                                                Quantity Ordered
                                                                <div className='ms-2'>
                                                                    <BsFileArrowUpFill /> <BsFileArrowDownFill />
                                                                </div>
                                                            </div>
                                                        </th>
                                                        <th onClick={() => this.arreglarLista2('QuantityShipped')}>
                                                            {this.state.General.Mode === 'S/O' ? 
                                                                <div className='d-flex justify-content-center align-items-center'>
                                                                    Quantity Shipped
                                                                    <div className='ms-2'>
                                                                        <BsFileArrowUpFill /> <BsFileArrowDownFill />
                                                                    </div>
                                                                </div>
                                                            : 
                                                                <div className='d-flex justify-content-center align-items-center'>
                                                                    Quantity Received
                                                                </div>
                                                            }
                                                        </th>
                                                        <th onClick={() => this.arreglarLista2('LineWeight')}>
                                                            <div className='d-flex justify-content-center align-items-center'>
                                                                Weight
                                                                <div className='ms-2'>
                                                                    <BsFileArrowUpFill /> <BsFileArrowDownFill />
                                                                </div>
                                                            </div>
                                                        </th>
                                                        <th onClick={() => this.arreglarLista2('TotalLineWeight')}>
                                                            <div className='d-flex justify-content-center align-items-center'>
                                                                Total Weight
                                                                <div className='ms-2'>
                                                                    <BsFileArrowUpFill /> <BsFileArrowDownFill />
                                                                </div>
                                                            </div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.OrderDetailPicked.map((item, i) => (
                                                        <tr hidden={this.state.General.Mode === 'S/O' && (item.Pallet === -1 || (!item.LineSeqNo))} onClick={() => this.RemoveProductPickedList(item)} key={i}>
                                                            <td className='text-start' style={{ paddingTop: 20, paddingBottom: 20 }}>
                                                                <div className='badge blueLightBackground'>{item.LineSeqNo}</div>
                                                            </td>
                                                            <td className='text-start' style={{ paddingTop: 20, paddingBottom: 20 }}>
                                                                {item.ItemCode}
                                                            </td>
                                                            <td className='text-start' style={{ paddingTop: 20, paddingBottom: 20 }}>
                                                                {item.ItemCodeDesc}
                                                                
                                                                {/* Comment */}
                                                                {item.CommentText ? 
                                                                    <p className='blueLightBackground'>
                                                                        Comments: {item.CommentText}
                                                                    </p>
                                                                : null}
                                                            </td>
                                                            <td className='text-center' style={{ paddingTop: 20, paddingBottom: 20 }}>
                                                                {NumberFormat(pricesFormat(item.QuantityOrdered))}
                                                            </td>
                                                            <td className='text-center' style={{ paddingTop: 20, paddingBottom: 20 }}>
                                                                {NumberFormat(pricesFormat(item.QuantityShipped))}
                                                            </td>
                                                            <td className='text-center' style={{ paddingTop: 20, paddingBottom: 20 }}>
                                                                {NumberFormat(pricesFormat(item.LineWeight))}
                                                            </td>
                                                            <td className='text-center' style={{ paddingTop: 20, paddingBottom: 20 }}>
                                                                {NumberFormat(pricesFormat(item.TotalLineWeight))}
                                                            </td>
                                                        </tr>
                                                    ))}

                                                </tbody>
                                                <tfoot className='tfoot'>
                                                    <tr className='text-light text-center darkPurpleBackground'>
                                                        <td></td>
                                                        <td></td>
                                                        <td className=''>Totals</td>
                                                        <td className=''>{NumberFormat(this.state.Totals.OrderDetailPicked.QuantityOrdered)}</td>
                                                        <td className=''>{NumberFormat(this.state.Totals.OrderDetailPicked.QuantityShipRec)}</td>
                                                        <td></td>
                                                        <td className=''>{NumberFormat(pricesFormat(this.state.Totals.OrderDetailPicked.TotalWeight))}</td>
                                                        <td></td>
                                                    </tr>
                                                </tfoot>

                                            </table>
                                        </div>
                                    </div>

                                    <div className='col-sm-12'>
                                        <div className='row d-flex justify-content-center'>
                                            <div className='col-sm-6 pb-3'>
                                                <button type="button" disabled={this.state.ActualHeaderOrder.Status === 2 || this.state.ActualHeaderOrder.Status === '2' || this.state.ActualHeaderOrder.Status === ''} onClick={() => this.confirmCompletePick()} className="btn btn-primary btn-lg w-100"><AiTwotoneSave /> Finish Order</button>
                                            </div>
                                            
                                            <div className='col-sm-8 pb-2'>
                                                {MobileDisp() ?
                                                    <OrderPDF
                                                        id={"PrintPickOrder"} disabled={this.state.ActualHeaderOrder.Status === ''} colorButton="yellowButton" title="Print Order"
                                                        companyLogo={getValueCookie('DocumentsLogo')}
                                                        OrderTitle="Picked Up List"
                                                        contactInfo={this.state.companyPrintHeader}
                                                        OrderInfo1={["Order No: ", this.state.ActualHeaderOrder.OrderNo, "Order by: ", this.state.ActualHeaderOrder.SalesPerson, "No Vendor: ", this.state.ActualHeaderOrder.OrderNameNo, "Printed by: ", getValueCookie('userName'), "Vendor: ", this.state.ActualHeaderOrder.OrderName2, "Printed Date: ", FormatQueryReturnDateForReport(getActualDateUTC()), "Date: ", (formatInputDateQuery(this.state.ActualHeaderOrder.Date) !== "" ? formatInputDateQuery(this.state.ActualHeaderOrder.Date) : DateFormatMAS90(this.state.ActualHeaderOrder.Date)), this.state.ActualHeaderOrder.ZipCode !== '' ? "Zip Code:" : "", this.state.ActualHeaderOrder.ZipCode, this.state.ActualHeaderOrder.State !== '' ? "State:" : "", this.state.ActualHeaderOrder.State !== '' ? this.state.ActualHeaderOrder.State : ""]}
                                                        headerTable={["\n Item Code", "\n Description", "\nPallet", "\n Quantity \n Ordered", this.state.General.Mode === 'S/O' ? "\n Quantity \n Shipped" : "\n Quantity \n Received", "\n Total\n Weight", "\n Time\n Stamp", "User\nName\n"]}
                                                        bodyTable={this.formatDatePickedUp()}
                                                        headerBodyTable={["ItemCode", "ItemCodeDesc", "Pallet", "QuantityOrdered", "QuantityShipped", "TotalLineWeight", "receivedDate2", "UserName"]}
                                                        bottomInfo={["", "TOTALS:", "", NumberFormat(this.state.Totals.OrderDetailPicked.QuantityOrdered), NumberFormat(this.state.Totals.OrderDetailPicked.QuantityShipRec), NumberFormat(pricesFormat(this.state.Totals.OrderDetailPicked.TotalWeight)), "", ""]}
                                                        styleColumns={["ColumnaTextoNormalLeft", "ColumnaTextoLargo2", "ColumnaCantidades", "ColumnaCantidades", "ColumnaCantidades", "ColumnaCantidades", "ColumnaTextoNormal", "ColumnaCantidades"]}
                                                        hidden={false}
                                                        comment={''}
                                                        breakpoint={30}
                                                        keysDecimalFormat={["TotalLineWeight"]}
                                                        titleButton='Print Order'
                                                    />
                                                    :
                                                    <DownloadOrderPDF
                                                        id={"PrintPickOrder"} disabled={this.state.ActualHeaderOrder.Status === ''} colorButton="blueButton" title="Print Order"
                                                        companyLogo={getValueCookie('DocumentsLogo')}
                                                        OrderTitle="Picked Up List"
                                                        contactInfo={this.state.companyPrintHeader}
                                                        OrderInfo1={["Order No: ", this.state.ActualHeaderOrder.OrderNo, "Order by: ", this.state.ActualHeaderOrder.SalesPerson, "No Vendor: ", this.state.ActualHeaderOrder.OrderNameNo, "Printed by: ", getValueCookie('userName'), "Vendor: ", this.state.ActualHeaderOrder.OrderName2, "Printed Date: ", FormatQueryReturnDateForReport(getActualDateUTC()), "Date: ", (formatInputDateQuery(this.state.ActualHeaderOrder.Date) !== "" ? formatInputDateQuery(this.state.ActualHeaderOrder.Date) : DateFormatMAS90(this.state.ActualHeaderOrder.Date)), this.state.ActualHeaderOrder.ZipCode !== '' ? "Zip Code:" : "", this.state.ActualHeaderOrder.ZipCode, this.state.ActualHeaderOrder.State !== '' ? "State:" : "", this.state.ActualHeaderOrder.State !== '' ? this.state.ActualHeaderOrder.State : ""]}
                                                        headerTable={["\n Item Code", "\n Description", "\nPallet", "\n Quantity \n Ordered", this.state.General.Mode === 'S/O' ? "\n Quantity \n Shipped" : "\n Quantity \n Received", "\n Total\n Weight", "\n Time\n Stamp", "User\nName\n"]}
                                                        bodyTable={this.formatDatePickedUp()}
                                                        headerBodyTable={["ItemCode", "ItemCodeDesc", "Pallet", "QuantityOrdered", "QuantityShipped", "TotalLineWeight", "receivedDate2", "UserName"]}
                                                        bottomInfo={["", "TOTALS:", "", NumberFormat(this.state.Totals.OrderDetailPicked.QuantityOrdered), NumberFormat(this.state.Totals.OrderDetailPicked.QuantityShipRec), NumberFormat(pricesFormat(this.state.Totals.OrderDetailPicked.TotalWeight)), "", ""]}
                                                        styleColumns={["ColumnaTextoNormalLeft", "ColumnaTextoLargo2", "ColumnaCantidades", "ColumnaCantidades", "ColumnaCantidades", "ColumnaCantidades", "ColumnaTextoNormal", "ColumnaCantidades"]}
                                                        hidden={false}
                                                        comment={''}
                                                        breakpoint={30}
                                                        keysDecimalFormat={["TotalLineWeight"]}
                                                        titleButton='Print Order'
                                                        docname={this.state.ActualHeaderOrder.OrderNo}
                                                    />
                                                }

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                : null}

                {/* Modal for SO list */}
                <ModalOrders title={'Open ' + this.state.General.ModeTitle} show={this.state.General.showModal1} close={(modal = "showModal1") => this.handleModalClose(modal)}>
                    <div className='row'>
                        <div className='col-12 mt-2'>
                            <div className="input-group input-group-lg flex-nowrap" style={{ marginBottom: 0 }}>
                                <input type="text" autoComplete='off' className="form-control inputResize" value={this.state.searchText} onChange={(e) => this.setState({ searchText: e.target.value })} />

                                <button type="button" className="btn blueButton btn-lg" onClick={this.handleSearchOrders}><AiOutlineSearch /></button>
                            </div>
                        </div>

                        <div className='col-12 tableFixHead tb-1' style={{ marginTop: 40 }}>
                            <table className='table table-striped'>
                                <thead>
                                    <tr className='text-center' style={{ backgroundColor: 'white !important' }}>
                                        <th onClick={() => this.GeneralOrder('Status', this.state.order, 'OrderHeaderList')}>
                                            <div className='d-flex justify-content-center'>
                                                Status
                                                <div className='ms-1'><BsFileArrowUpFill /><BsFileArrowDownFill /></div>
                                            </div>
                                        </th>
                                        <th onClick={() => this.GeneralOrder('OrderNo', this.state.order, 'OrderHeaderList')}>
                                            <div className='d-flex justify-content-center'>
                                                Order
                                                <div className='ms-1'><BsFileArrowUpFill /><BsFileArrowDownFill /></div>
                                            </div>
                                        </th>
                                        <th onClick={() => this.GeneralOrder('OrderName', this.state.order, 'OrderHeaderList')}>
                                            <div className='d-flex justify-content-center'>
                                                Customer
                                                <div className='ms-1'><BsFileArrowUpFill /><BsFileArrowDownFill /></div>
                                            </div>
                                        </th>
                                        <th hidden={this.state.General.Mode === 'P/O'} onClick={() => this.GeneralOrder('PriceLevel', this.state.order, 'OrderHeaderList')}>
                                            <div className='d-flex justify-content-center'>
                                                Price level
                                                <div className='ms-1'><BsFileArrowUpFill /><BsFileArrowDownFill /></div>
                                            </div>
                                        </th>
                                        <th hidden={this.state.General.Mode === 'S/O'} onClick={() => this.GeneralOrder('completionDate', this.state.order, 'OrderHeaderList')}>
                                            <div className='d-flex justify-content-center'>
                                                Est. complete date
                                                <div className='ms-1'><BsFileArrowUpFill /><BsFileArrowDownFill /></div>
                                            </div>
                                        </th>                            
                                        <th onClick={() => this.GeneralOrder('Date', this.state.order, 'OrderHeaderList')}>
                                            <div className='d-flex justify-content-center'>
                                                Updated date
                                                <div className='ms-1'><BsFileArrowUpFill /><BsFileArrowDownFill /></div>
                                            </div>
                                        </th>
                                        <th hidden onClick={() => this.GeneralOrder('CompleteDate', this.state.order, 'OrderHeaderList')}>
                                            <div className='d-flex justify-content-center'>
                                                Completed date
                                                <div className='ms-1'><BsFileArrowUpFill /><BsFileArrowDownFill /></div>
                                            </div>
                                        </th>
                                        <th onClick={() => this.GeneralOrder('SalesPerson', this.state.order, 'OrderHeaderList')}>
                                            <div className='d-flex justify-content-center'>
                                                Sales person
                                                <div className='ms-1'><BsFileArrowUpFill /><BsFileArrowDownFill /></div>
                                            </div>
                                        </th>
                                        <th hidden={this.state.General.Mode === 'P/O'} onClick={() => this.GeneralOrder('PosQue', this.state.order, 'OrderHeaderList')}>
                                            <div className='d-flex justify-content-center'>
                                                Queque
                                                <div className='ms-1'><BsFileArrowUpFill /><BsFileArrowDownFill /></div>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.filteredOrderList.map((order, i) => (
                                            <tr hidden={(order.OrderType !== 'S' && this.state.General.Mode === 'S/O')} onClick={() => this.SelectOrdertoPickUp(order)} key={i} style={{ cursor: 'pointer' }}>
                                                <td className='text-center' style={{ paddingTop: 20, paddingBottom: 20 }}>
                                                    <span className={"badge "+ this.stateClassColor(order.Status) +"Background d-flex align-items-center justify-content-center" }>
                                                        {this.statusIcon(order.Status, this.state.General.Mode)} 
                                                        <span className='ms-2'>{this.stateInWords(order.Status)}</span>
                                                    </span>
                                                </td>
                                                <td className='text-center' style={{ paddingTop: 20, paddingBottom: 20 }}>
                                                    {order.OrderNo}
                                                </td>
                                                <td style={{ paddingTop: 20, paddingBottom: 20 }}>
                                                    {order.OrderName}
                                                </td>
                                                <td className='text-center' style={{ paddingTop: 20, paddingBottom: 20 }} hidden={this.state.General.Mode === 'P/O'}>
                                                    {order.PriceLevel}
                                                </td>
                                                <td className='text-center' style={{ paddingTop: 20, paddingBottom: 20 }} hidden={this.state.General.Mode === 'S/O'}>
                                                    {formatInputDateQuery(order.completionDate)}
                                                </td>
                                                <td className='text-center' style={{ paddingTop: 20, paddingBottom: 20 }}>
                                                    {formatInputDateQuery(order.Date) !== "" ? formatInputDateQuery(order.Date) : DateFormatMAS90(order.Date) + " " + order.DateTime}
                                                </td>
                                                <td hidden className='text-center' style={{ paddingTop: 20, paddingBottom: 20 }}>
                                                    {order.CompleteDate}
                                                </td>
                                                <td className='text-center' style={{ paddingTop: 20, paddingBottom: 20 }}>
                                                    {order.SalesPerson}
                                                </td>
                                                <td hidden={(this.state.General.Mode === 'P/O')} className='text-center' style={{ paddingTop: 20, paddingBottom: 20 }}>
                                                    {order.PosQue === 999 ? 
                                                        <span className='badge greenBackground'><AiOutlineCheckCircle size={16} /></span> 
                                                    : 
                                                        <span className='badge blueLightBackground'>{order.PosQue}</span>
                                                    }
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                                <tfoot className='tfoot'>
                                </tfoot>

                            </table>
                        </div>

                    </div>
                </ModalOrders>
                
                {/* Picked item modal */}
                <ModalOrders title={this.state.General.Mode === 'S/O' ? 'Quantity to Pack' : 'Quantity Received'} show={this.state.General.showModal2} close={(modal = "showModal2") => this.handleModalClose(modal)}>
                    <div className='row mt-4'>

                        <div className='col-sm-12 col-md-4'>
                            <div className='image-box'>
                                <div className='ItemImage'>
                                    <img key={this.state.CurrentItem.ImgURL} className='' id='ShortsProductImg' src={(this.state.CurrentItem.ImgURL && this.state.CurrentItem.ImgURL !== '') ? this.state.CurrentItem.ImgURL : '/assets/notavailable.png'} alt='ProductImg' />
                                </div>
                            </div>
                        </div>

                        <div className='col-sm-12 col-md-8'>
                            <div className='col-sm-12 pb-3 text-start'>
                                <h4 class='d-flex align-items'>
                                    <span className='badge purpleBackground' style={{ fontWeight: 'normal' }}>{this.state.CurrentItem.ItemCode}</span>
                                    <span className='ms-2'>{this.state.CurrentItem.Description}</span>
                                </h4>
                            </div>
                            
                            <div className='col-sm-12 pb-3 text-center'>
                                <div className="input-group input-group-lg fs-4">
                                    <button className={"button purpleLightButton btn-lg"} style={{ fontWeight: 'normal', fontSize: '1rem' }} onClick={() => {}}>BIN</button>

                                    <input value={this.state.CurrentItem.BIN ? this.state.CurrentItem.BIN : '-'} disabled type="text" autoComplete='off' className="form-control text-center" id='' />
                                </div>
                            </div>

                            <div className='col-sm-12 pb-3 text-center'>
                                <div className="input-group input-group-lg fs-4">
                                    <button className={"button purpleLightButton btn-lg"} style={{ fontWeight: 'normal', fontSize: '1rem' }} onClick={() => {}}>On Hand</button>
                                    <input disabled type="number" autoComplete='off' value={this.state.CurrentItem.onHand} className="form-control text-center" id='' />

                                    <button className={"button purpleLightButton btn-lg ms-2"} style={{ fontWeight: 'normal', fontSize: '1rem' }} onClick={() => {}}>Quantity Ordered</button>
                                    <input disabled type="number" autoComplete='off' value={this.state.CurrentItem.QuantityOrdered} className="form-control text-center" id='' />
                                </div>
                            </div>

                            <div className='col-sm-12 text-center'>
                                <div className="input-group input-group-lg fs-4">
                                    <button className={"button purpleLightButton btn-lg"} style={{ fontWeight: 'normal', fontSize: '1rem' }} onClick={() => {}}>Pallet</button>
                                    <select defaultValue={this.state.General.currentPallet} className="form-select form-select-lg" id='palletPickingSystem' onChange={this.onTarget}>
                                        {['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16'].map(element => (
                                            <option key={element} className='text-center'>{element}</option>
                                        ))}
                                    </select>

                                    <button className={"button purpleLightButton btn-lg ms-2"} style={{ fontWeight: 'normal', fontSize: '1rem' }} onClick={() => {}}>{this.state.General.Mode === 'S/O' ? 'Quantity Shipped' : 'Quantity Received'}</button>
                                    <input type="number" min={0} autoComplete='off' onChange={(e) => this.changeInputShipped(e)} defaultValue={this.state.CurrentItem.QuantityShipRec} className="form-control text-center" id='quantityShipRecPickingSystem' />
                                </div>
                            </div>

                            {this.state.General.Mode === 'P/O' ?
                                <>
                                    <div className='col-sm-12 text-center'>
                                        <div className="input-group input-group-lg fs-4">
                                            <span className='input-group-text product-input-text'>Expiration Date</span>
                                            <input type="date" autoComplete='off' value={this.state.CurrentItem.DueDate ? this.formatDate(this.state.CurrentItem.DueDate) : this.state.CurrentItem.DueDate} onChange={(e) => this.changeDueDate(e)} className="form-control text-center" id='dueDatePickingSystem' />
                                        </div>
                                    </div>
                                </> : <></>
                            }

                            <hr />

                            <div className='row d-flex justify-content-center mt-4'>
                                <div className='col-12'>
                                    <button type="button" className="btn btn-primary btn-lg mb-3" onClick={() => this.confirmPickItem()} style={{ width: '100%' }}>
                                        <AiOutlineCheckCircle /> <span className='ms-2'>Confirm</span>
                                    </button>

                                    <button type="button" className="btn btn-outline-secondary btn-lg" onClick={() => this.handleModalClose("showModal2")} style={{ width: '100%' }}>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalOrders>
            </div>
        )
    }
}
